<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Visor de Documentos Recibidos
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Análisis</span>
      <span> /</span>
      <span>Visor de Documentos Recibidos </span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <!-- <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
        <div></div>
        <button type="button" mdbBtn color="info" size="sm" mdbWavesEffect (click)="agregarDocumentoRecibido.show()">
          Agregar documento electrónico recibido
        </button>
      </div> -->
      <div class="row filtros-body">
        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaDesde" placeholder="Desde" required
              formControlName="fechaDesde"></mdb-date-picker>
          </div>
        </div>

        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaHasta" placeholder="Hasta" required
              formControlName="fechaHasta"></mdb-date-picker>
          </div>
        </div>

        <div class="col" style="max-width: 200px">
          <div class="md-form">
            <mdb-select [options]="optionsTipoDocumento" [multiple]="false" [filterEnabled]="true"
              [highlightFirst]="false" placeholder="Seleccionar tipo de documento" formControlName="tipoDocumento">
            </mdb-select>
            <label>Tipo de Documento</label>
            <!-- <mdb-error *ngIf="formHeader.get('tipoDocumento').hasError('required')">Ingrese tipo de documento
            </mdb-error> -->
          </div>
        </div>

        <div class="col" style="max-width: 200px">
          <div class="md-form">
            <mdb-select [options]="optionsTipoVisor" [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar tipo de visor" formControlName="tipoVisor">
            </mdb-select>
            <label>Tipo de Visor</label>
            <mdb-error *ngIf="formHeader.get('tipoVisor').hasError('required')">Ingrese tipo de visor
            </mdb-error>
          </div>
        </div>


        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsStatusDocumento" [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar status documento" formControlName="statusDocumento">
            </mdb-select>
            <label>Status de Documentos</label>
            <mdb-error *ngIf="formHeader.get('statusDocumento').hasError('required')">Ingrese status documento
            </mdb-error>
          </div>
        </div>

        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsTipoDetalle" [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Tipo de Detalle" formControlName="tipoDetalle">
            </mdb-select>
            <label>Tipo de Detalle</label>
            <mdb-error *ngIf="formHeader.get('tipoDetalle').hasError('required')">Ingrese tipo de detalle
            </mdb-error>
          </div>
        </div>

      </div>



      <!-- <div class="row filtros-body">
        <div class="col">
          <pre>{{formHeader.value | json}}</pre>
        </div>
      </div> -->

    </div>
    <!-- FOOTER -->

    <div class="card-footer text-muted filtros-footer justify-content-end" style="border-top: 1px solid #dee2e6">
      <button mdbBtn type="button" color="info" size="sm" mdbWavesEffect (click)="limpiarfiltros()">
        <mdb-icon fas icon="broom"></mdb-icon>
        Limpiar
      </button>
      
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="startSearch()">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>

      
    </div>
  </div>
</form>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="table-responsive" *ngIf="listaDocumentos">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <!-- <th scope="col">Tipo</th> -->
            <th scope="col">Detalle Documento</th>
            <th scope="col">Cantidad</th>
            <th scope="col">Monto Neto</th>
            <th scope="col">Monto Exento</th>
            <th scope="col">Imp.Adic</th>
            <th scope="col">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td scope="col" colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
          <tr *ngIf="!loading && listaDocumentos?.length === 0">
            <td scope="col" colspan="100%" style="text-align: center">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let doc of listaDocumentos">
            <!-- <th scope="col">{{ doc.tipoDescripcionAbreviada }}</td> -->
            <td scope="col">
              <div
                [ngClass]="{'custom_link c-pointer': (formHeader.get('tipoVisor').value !== null && formHeader.get('tipoDetalle').value !== null) || (formHeader.get('tipoVisor').value == TIPO_VISOR.IMPORTACION)}"
                (click)="showDetails(doc.tipo_dte_codigo)"> {{
                doc.tipoDescripcion }} </div>
            </td>
            <td scope="col">{{ doc.cantidad | numerico }}</td>
            <td scope="col">{{ doc.monto_neto | numerico }}</td>
            <td scope="col">{{ doc.monto_exento | numerico }}</td>
            <td scope="col">{{ doc.impuesto_adicional | numerico }}</td>
            <td scope="col">{{ doc.total | numerico }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-empresas-recibidos-table-intercambio-empresas [visible]="showEstadoIntercambioEmpresas">
</app-empresas-recibidos-table-intercambio-empresas>

<app-empresas-recibidos-table-intercambio-sii [visible]="showEstadoIntercambioSII">
</app-empresas-recibidos-table-intercambio-sii>

<app-empresas-recibidos-table-importacion [visible]="showImportacion">
</app-empresas-recibidos-table-importacion>


<div class="card mb-2 wow" *ngIf="listaDocumentos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="downloadExcel()">
      Excel
    </button>
  </div>
</div>

<!-- MODAL observacionesModal -->
<app-empresas-recibidos-modal-observaciones></app-empresas-recibidos-modal-observaciones>

